/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const UpgradedLTIProviderExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['upgraded_lti1p3_id', codecString]]), BaseError);
export class UpgradedLTIProviderException extends BaseError {
    static decode(input) {
        return UpgradedLTIProviderExceptionParser.decode(input).map(res => new UpgradedLTIProviderException(res));
    }
    static unsafeDecode(input) {
        return UpgradedLTIProviderException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UpgradedLTIProviderExceptionParser.encode(data);
    }
    static schema() {
        return UpgradedLTIProviderExceptionParser.schema();
    }
}
